import { useTranslation } from 'react-i18next';
import { ON_CHAIN_WLD_LOGO } from '../lib/tokenLogos';

type WldInfoModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onOpenTopUp: () => void;
};

export default function WldInfoModal({
  isOpen,
  onClose,
  onOpenTopUp,
}: WldInfoModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section className="wld-info-modal" role="dialog" aria-modal="true" aria-label={t('wld.title')}>
        <div className="modal-header modal-header-close-only">
          <button className="modal-close-button" type="button" onClick={onClose} aria-label={t('wld.close')}>
            ×
          </button>
        </div>

        <div className="bbt-info-content">
          <div className="wld-info-identity">
            <img className="wld-info-logo" src={ON_CHAIN_WLD_LOGO} alt="WLD logo" />
            <strong>{t('wld.tokenName')}</strong>
          </div>
          <p className="wld-info-description">{t('wld.description')}</p>
          <div className="bbt-info-actions">
            <button className="auth-button wld-top-up-button" type="button" onClick={onOpenTopUp}>
              {t('wld.topUpWld')}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
